import React, { useState } from 'react';
import classes from './block2.module.css';
import servicesData from '../../../data/services.json';
import { API_BASE_URL } from '../../../config/api';

const Block2 = ({ activeCategoryId: externalActiveCategoryId, onCategoryChange }) => {
    const [categories, setCategories] = useState(servicesData);
    const [internalActiveCategoryId, setInternalActiveCategoryId] = useState(servicesData[0]?.id ?? null);
    const activeCategoryId = externalActiveCategoryId ?? internalActiveCategoryId;

    React.useEffect(() => {
        fetch(`${API_BASE_URL}/api/services/`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to load services');
                }
                return response.json();
            })
            .then((data) => {
                if (!Array.isArray(data) || data.length === 0) {
                    return;
                }
                setCategories(data);

                const firstId = data[0]?.id ?? null;
                if (!externalActiveCategoryId && firstId) {
                    setInternalActiveCategoryId((prev) => {
                        const hasPrevious = data.some((category) => category.id === prev);
                        return hasPrevious ? prev : firstId;
                    });
                }
            })
            .catch(() => {
                setCategories(servicesData);
            });
    }, [externalActiveCategoryId]);

    const setActiveCategoryId = (categoryId) => {
        if (onCategoryChange) {
            onCategoryChange(categoryId);
            return;
        }
        setInternalActiveCategoryId(categoryId);
    };

    const activeCategory = categories.find((c) => c.id === activeCategoryId);
    const services = activeCategory?.services ?? [];

    const formatPrice = (price, duration) => {
        const normalizedPrice = typeof price === 'number' ? String(price) : String(price || '').trim();
        const normalizedDuration = String(duration || '').trim();

        if (normalizedPrice === '0') return 'Бесплатно';
        if (!normalizedDuration) return `${normalizedPrice} р`;
        return `${normalizedPrice} р / ${normalizedDuration} мин`;
    };

    return (
        <div className={classes._} id="prices">
            <div className={classes.block}>
                <div className={classes.text1}>Услуги и цены</div>
            </div>
            <div className={classes.tabsRow}>
                <div className={classes.tabs}>
                    {categories.map((cat) => (
                        <button
                            key={cat.id}
                            type="button"
                            className={
                                activeCategoryId === cat.id
                                    ? `${classes.tab} ${classes.tabActive}`
                                    : classes.tab
                            }
                            onClick={() => setActiveCategoryId(cat.id)}
                        >
                            <div>{cat.title}</div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
                                <circle cx="2.5" cy="2.5" r="2.5" fill="#17181A"/>
                            </svg>
                            <span className={classes.tabCount}>
                                 {cat.services.length}</span>
                        </button>
                    ))}
                </div>
            </div>
            <div className={classes.block}>
                <div className={classes.servicesGridDesktop}>
                    <div className={classes.servicesColumn}>
                        {services
                            .filter((_, i) => i % 2 === 0)
                            .map((service) => (
                                <div key={service.id} className={classes.serviceCard}>
                                    <div className={classes.serviceName}>{service.name}</div>
                                    <div className={classes.servicePrice}>
                                        {formatPrice(service.price, service.duration)}
                                    </div>
                                    <p className={classes.serviceDescription}>
                                        {service.description}
                                    </p>
                                </div>
                            ))}
                    </div>
                    <div className={classes.servicesColumn}>
                        {services
                            .filter((_, i) => i % 2 === 1)
                            .map((service) => (
                                <div key={service.id} className={classes.serviceCard}>
                                    <div className={classes.serviceName}>{service.name}</div>
                                    <div className={classes.servicePrice}>
                                        {formatPrice(service.price, service.duration)}
                                    </div>
                                    <p className={classes.serviceDescription}>
                                        {service.description}
                                    </p>
                                </div>
                            ))}
                    </div>
                </div>
                <div className={classes.servicesGridMobile}>
                    {services.map((service) => (
                        <div key={`mobile-${service.id}`} className={classes.serviceCard}>
                            <div className={classes.serviceName}>{service.name}</div>
                            <div className={classes.servicePrice}>
                                {formatPrice(service.price, service.duration)}
                            </div>
                            <p className={classes.serviceDescription}>
                                {service.description}
                            </p>
                        </div>
                    ))}
                </div>
                <a
                    href="https://widget.sonline.su/ru/services/?placeid=852816903"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.botton}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="45" viewBox="0 0 40 45" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M34.8024 33.2511C35.2379 32.6908 37.2318 27.8832 33.2087 24.8557C30.8475 23.0789 28.2276 23.4708 26.7807 24.1308C25.3339 24.7907 24.9505 25.2871 24.013 25.1923C23.166 25.1066 21.7785 23.6797 21.1538 23.2012C20.654 22.8183 12.1518 15.3183 7.88239 11.5727C5.85743 9.77704 1.67953 6.08342 1.16758 5.67396C0.527627 5.16213 -0.124892 5.78125 0.0202394 6.27766C0.165371 6.77407 1.86085 9.77823 3.32676 11.9226C4.79267 14.067 7.30963 17.1787 8.99394 18.8216C10.3414 20.136 11.7448 21.3176 12.2477 21.6776C12.2239 24.18 12.1642 29.319 12.1161 29.8553C12.0561 30.5256 11.8463 31.2241 11.0453 31.4287C10.2444 31.6333 7.81311 32.5414 6.70533 34.2121C5.59754 35.8828 4.9325 38.758 6.43997 41.205C8.00542 43.746 10.5996 44.5319 12.7418 44.2379C14.8841 43.9439 17.2474 42.2632 18.1322 39.5689C19.017 36.8747 17.3908 34.2006 16.8399 33.5276C16.289 32.8546 15.2012 31.9845 15.217 30.7717C15.2329 29.5588 15.635 26.9272 15.7839 26.1328C15.9733 25.1221 16.7908 24.5081 17.7118 25.0123C18.6328 25.5165 20.7089 26.8601 21.3977 27.3899C22.0865 27.9196 22.6558 28.544 22.7495 29.9078C22.8431 31.2716 23.481 33.4722 25.2089 34.8541C26.9367 36.2361 28.6283 36.4691 30.2725 36.2416C31.5878 36.0596 32.374 35.5911 32.6027 35.3796C33.1129 35.6961 34.4878 36.3041 35.9055 36.204C37.6776 36.0788 39.0855 35.1553 39.3593 34.508C39.6332 33.8607 38.9074 33.4282 38.5188 33.6456C38.1302 33.863 36.7856 34.0343 36.2757 33.9856C35.8677 33.9467 35.1235 33.4797 34.8024 33.2511ZM16.1285 21.2738C15.8687 20.7043 15.1951 20.4647 14.615 20.7184C14.0254 20.9762 13.7446 21.662 14.0086 22.2408C14.2726 22.8196 14.9746 23.057 15.5557 22.7808C16.1276 22.509 16.3882 21.8433 16.1285 21.2738ZM32.9844 28.3739C32.1103 26.3319 29.6408 25.4333 27.614 26.403C25.6238 27.3552 24.7652 29.7261 25.7164 31.689C26.6678 33.6524 29.0626 34.4489 31.0445 33.4784C32.9706 32.5351 33.8187 30.3231 32.9844 28.3739ZM15.6556 36.2781C14.7816 34.236 12.312 33.3375 10.2853 34.3072C8.29502 35.2594 7.43602 37.6305 8.38763 39.5932C9.31707 41.5102 11.5709 42.3175 13.5476 41.4593C15.5622 40.5845 16.51 38.2743 15.6556 36.2781Z"
                              fill="#4F4230" fill-opacity="0.5"/>
                        <path
                            d="M12.1424 14.0501C12.1077 10.6768 12.0383 3.76964 12.0378 3.12689C12.0372 2.32345 12.0095 1.3716 12.0022 0.731921C11.995 0.092241 12.9741 -0.434728 13.4141 0.529966C13.8542 1.49466 14.7685 4.21214 15.2276 5.93166C15.6868 7.65117 16.0311 8.94081 16.3286 10.5733C16.6261 12.2058 16.8926 15.0179 16.9302 15.7241C16.9602 16.2891 16.9497 17.6977 16.9406 18.3314L12.1424 14.0501Z"
                            fill="#4F4230" fill-opacity="0.5"/>
                    </svg>
                    Выбрать дату и время
                </a>
            </div>
        </div>
    );
};

export default Block2;
